// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"cd6458a0be022b9da96d","691":"6b7fd8fe68ae4b7ef54d","731":"8d3d055e2a7e17fb5e21","843":"b0882d454c91b481cc85"}[chunkId] + ".js";
};